var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTextField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9725 12.6L13.1003 3.47221L11.8277 2.19961L2.6999 11.3274V12.6H3.9725ZM4.7186 14.4H0.899902V10.5813L11.1914 0.289814C11.3602 0.12109 11.5891 0.0263062 11.8277 0.0263062C12.0664 0.0263062 12.2952 0.12109 12.464 0.289814L15.0101 2.83591C15.1788 3.00469 15.2736 3.23357 15.2736 3.47221C15.2736 3.71086 15.1788 3.93974 15.0101 4.10851L4.7186 14.4V14.4ZM0.899902 16.2H17.0999V18H0.899902V16.2Z",
    fill: "#868C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextField);
export default __webpack_public_path__ + "static/media/edit-text-field.684017c69645e1cffcab6a50e185ea59.svg";
export { ForwardRef as ReactComponent };